import { Injectable } from '@angular/core';
import { Action, NgxsOnInit, Selector, State, StateContext, StateToken } from '@ngxs/store';

import { ScheduleActions } from './store.action';

import { StateModel } from './store.model';

export const schedulesDefaults: StateModel = {
  eventPrice: 0,
  calendarFilter: null,
  searchFilter: null
};

export const PARTNER_SCHEDULES_STATE_TOKEN = new StateToken<StateModel>('domain_schedules');

@State<StateModel>({
  name: PARTNER_SCHEDULES_STATE_TOKEN,
  defaults: schedulesDefaults
})
@Injectable()
export class PartnerWebScheduleState implements NgxsOnInit {

  @Selector()
  static eventPrice(state: StateModel): number {
    return state.eventPrice!;
  }

  @Selector()
  static calendarFilter(state: StateModel): string {
    return state.calendarFilter!;
  }

  @Selector()
  static searchFilter(state: StateModel): string {
    return state.searchFilter!;
  }

  constructor() { }

  ngxsOnInit(): void { }

  @Action(ScheduleActions.UpdateEventPrice)
  updateEventPrice( ctx: StateContext<StateModel>, action: ScheduleActions.UpdateEventPrice): void {
    ctx.patchState({ eventPrice: action.price });
  }

  @Action(ScheduleActions.UpdateCalendarFilter)
  updateCalendarFilter( ctx: StateContext<StateModel>, action: ScheduleActions.UpdateCalendarFilter): void {
    ctx.patchState({ calendarFilter: action.state });
  }

  @Action(ScheduleActions.UpdateSearchFilter)
  updateSearchFilter( ctx: StateContext<StateModel>, action: ScheduleActions.UpdateSearchFilter): void {
    ctx.patchState({ searchFilter: action.state });
  }

}
